import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const gqlAutomaticPayment = `
    id
    payment_token
    payment_type
    billing_party_member_id
    payment_frequency
    last_four
    routing_number
`;
